const CHUNK_SIZE = 64000; // 64 KB
const MAX_PARTITION_SIZE = 1e6; // 1 MB

/** Reads a File in 64KB chunks, pausing at 1MB partition boundaries. The transfer
 *  protocol (chunk size, partition size, offsets, callbacks) matches the legacy
 *  FileReader-based implementation; only the read mechanism is modernized to
 *  Blob.arrayBuffer() so it runs without a DOM. */
export class FileChunker {
  private offset = 0;
  private partitionSize = 0;
  private readonly file: File;
  private readonly onChunk: (chunk: ArrayBuffer) => void;
  private readonly onPartitionEnd: (offset: number) => void;

  constructor(file: File, onChunk: (chunk: ArrayBuffer) => void, onPartitionEnd: (offset: number) => void) {
    this.file = file;
    this.onChunk = onChunk;
    this.onPartitionEnd = onPartitionEnd;
  }

  /** Reads chunks until the 1MB partition fills or the file ends. */
  async nextPartition(): Promise<void> {
    this.partitionSize = 0;
    while (true) {
      const slice = this.file.slice(this.offset, this.offset + CHUNK_SIZE);
      const chunk = await slice.arrayBuffer();
      this.offset += chunk.byteLength;
      this.partitionSize += chunk.byteLength;
      this.onChunk(chunk);
      if (this.isFileEnd()) return;
      if (this.partitionSize >= MAX_PARTITION_SIZE) {
        this.onPartitionEnd(this.offset);
        return;
      }
    }
  }

  repeatPartition(): Promise<void> {
    this.offset -= this.partitionSize;
    return this.nextPartition();
  }

  isFileEnd(): boolean {
    return this.offset >= this.file.size;
  }
}
